<template>
  <div>
    <v-dialog
      v-model="planDialog"
      width="1000px">
      <div class="dialog-container">
        <div class="plan-header">
          <div class="info flex">
            <span>Attach Customer</span>
            <i
              class="el-icon-close"
              @click="changeDialog"></i>
          </div>
        </div>
        <div class="dialog-body">
          <div class="flex-content">
            <attach-customer
              :isDialog="true"
              :orderId="orderId"
              :isShare="isShare"
              :formData="form"
              @customerData="handlerCustomerData"></attach-customer>
          </div>
        </div>
        <div class="flex footer-button">
          <v-button @click="changeDialog">Close</v-button>
          <v-button
            type="success"
            :disabled="!selectData.id"
            @click="ConfirmCoupon">Save</v-button>
        </div>
      </div>
    </v-dialog>
    <replace-dialog
      ref="replaceDialog"
      :selectData="selectData"
      @confirm="handlerConfirm"></replace-dialog>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import attachCustomer from '@/views/accounts/index'
import replaceDialog from './replace_pop_dialog'
import { addCustomer } from '@/api/order'
import { shareGuestAddCustomer } from '@/api/share'
export default {
  name: 'CouponDialog',
  components:{
    attachCustomer,
    replaceDialog
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form:{
      type:Object,
      default:()=>({})
    },
    isShare:{
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      planDialog: false,
      selectData:{}
    }
  },
  computed: {
    ...mapState('common', ['productId']),
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
      }
    },
  },
  methods: {
    ...mapActions('account', ['setCustomerId','setSelectCustomerData']),
    handlerConfirm(){
      this.network().addCustomer()
    },
    changeDialog() {
      this.planDialog = !this.planDialog
    },
    ConfirmCoupon(){
      this.planDialog =false
      let{is_replace_pop} = this.selectData||{}
      if(is_replace_pop){
        this.$refs.replaceDialog.changeDialog()
      }else{
        let params = {
          order_id: this.$route.query.order_id,
          customer_id:this.selectData.id,
        }
        this.network().addCustomer(params)
      }
    },
    handlerCustomerData(data){
      this.selectData =data
    },
    network() {
      return {
        addCustomer: async (params) => {
          if(this.isShare){
            await shareGuestAddCustomer(params)
          }else{
            await addCustomer(params)
          }
          this.$emit('addCustomer')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-dialog{
    border-radius: 4px;
  }
  .dialog-container {
    //padding: 15px;
    border-radius: 5px;
    .plan-header {
      background: #F6F8FA;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:10px 10px 10px 10px;
        font-size: 14px;
        font-weight: 600;
        color: #24292E;
        i{
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .dialog-body{
      padding: 15px;
      max-height: 800px;
      overflow-y: auto;
    }
    .footer-button{
      padding: 15px;
      justify-content: space-between;
    }
    .flex-content {
      //width: 280px;
      .flex-box {
        border-radius: 5px;
        border: 1px solid #E1E4E8;
        //width: 280px;
        margin: 16px 0;

        .flex-info {
          display: flex;
          justify-content: space-between;
          padding: 23px 15px;
          border-bottom: 1px solid #E1E4E8;

          span:first-child {
            color: #586069;
            font-size: 14px;
            font-weight: 500;
          }

          span:last-child {
            color: #24292E;
            font-size: 14px;
          }
        }

      }
    }
  }
</style>
